<template lang="html">
  <div class="card">
    <div class="image">
      <img :src="imageURL" />
    </div>
    <div class="content">
      <h4 class="title">{{ title }}</h4>
      <p class="description">{{ description }}</p>
      <router-link :to="getFormattedLink()">
        <Button variant="secondary">{{ buttonText }}</Button>
      </router-link>
    </div>
  </div>
</template>
<script>
import Button from "../General/Button.vue";

export default {
  props: {
    id: Number,
    imageURL: String,
    title: String,
    description: String,
    buttonText: String,
  },
  components: {
    Button,
  },
  methods: {
    escapeQuestionMark(text) {
      return text.replace(/\?/g, '%3F');
    },

    getFormattedLink() {
      const escapedTitle = this.escapeQuestionMark(this.title);
      return `/observatorio/${escapedTitle}?id=${this.id}`;
    },
  },
};
</script>
<style lang="css" scoped>
.card {
  width: 100% !important;
  background: transparent;
  border: none;
  text-align: left;
  margin: 0 15px;
}
.card .image {
  width: 100%;
  height: 180px;
  border-radius: 10px;
  overflow: hidden;
}
.image img {
  height: 100%;
}
.card .image img {
  width: 100%;
}
.card .content .title {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 23px;
  color: #ffffff;
  margin-top: 12px;
  margin-bottom: 10px;
}
.card .content .description {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #ffffff;
  margin-bottom: 25px;
}

@media (max-width: 768px) {
  .card .content .title {
    font-size: 16px;
    line-height: 19px;
  }
  .card .content .description {
    font-size: 14px;
    line-height: 20px;
  }
}
</style>
